"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var identifier_exports = {};
__export(identifier_exports, {
  allocateWithRetries: () => allocateWithRetries,
  parseIdentifier: () => parseIdentifier,
  requestIdentifierAllocation: () => requestIdentifierAllocation,
  requestNextIdentifier: () => requestNextIdentifier,
  requestNumberAllocation: () => requestNumberAllocation
});
module.exports = __toCommonJS(identifier_exports);
var import_component = __toESM(require("./component"));
var import_utils = require("./utils");
function parseIdentifier(code) {
  const match = code.match(/^(?<prefix>[\w-]+)-(?<sequence>\d+)$/);
  const prefix = match?.groups?.prefix;
  const sequence = match?.groups?.sequence;
  if (prefix === void 0 || sequence === void 0) return null;
  const parsedSequence = Number(sequence);
  if (!Number.isSafeInteger(parsedSequence) || parsedSequence < 1) return null;
  return { prefix, sequence: parsedSequence };
}
__name(parseIdentifier, "parseIdentifier");
const MAX_ALLOCATION_ATTEMPTS = 10;
async function requestNumberAllocation(client, request) {
  if (request.namespace.trim() === "" || request.sequence.trim() === "") {
    throw new Error("Allocation namespace and sequence are required");
  }
  const minimum = request.minimum ?? 1;
  if (!Number.isSafeInteger(minimum) || minimum < 1) {
    throw new Error("Allocation minimum must be a positive integer");
  }
  const scope = request.scope ?? "";
  const query = { namespace: request.namespace, scope, prefix: request.sequence };
  for (let attempt = 0; attempt < MAX_ALLOCATION_ATTEMPTS; attempt++) {
    let sequence = await client.findOne(import_component.default.class.CustomSequence, query);
    if (sequence === void 0) {
      const sequenceId = (0, import_utils.generateId)();
      const operations = client.apply("create-custom-sequence");
      operations.notMatch(import_component.default.class.CustomSequence, query);
      await operations.createDoc(
        import_component.default.class.CustomSequence,
        import_component.default.space.Workspace,
        {
          attachedTo: import_component.default.class.CustomSequence,
          namespace: request.namespace,
          scope,
          prefix: request.sequence,
          sequence: 0
        },
        sequenceId
      );
      if (!(await operations.commit()).result) continue;
      sequence = await client.findOne(import_component.default.class.CustomSequence, { _id: sequenceId });
      if (sequence === void 0) continue;
    }
    const increment = await client.update(sequence, { $inc: { sequence: 1 } }, true);
    let value = increment.object.sequence;
    if (value < minimum) {
      const advance = await client.update(sequence, { $inc: { sequence: minimum - value } }, true);
      value = advance.object.sequence;
    }
    return value;
  }
  throw new Error(`Unable to initialize sequence after ${MAX_ALLOCATION_ATTEMPTS} attempts`);
}
__name(requestNumberAllocation, "requestNumberAllocation");
async function requestIdentifierAllocation(client, request) {
  if (request.prefix.trim() === "") {
    throw new Error("Identifier prefix is required");
  }
  const sequence = await requestNumberAllocation(client, {
    namespace: request.namespace,
    scope: request.scope,
    sequence: request.prefix,
    minimum: request.minimum
  });
  return `${request.prefix}-${sequence}`;
}
__name(requestIdentifierAllocation, "requestIdentifierAllocation");
async function allocateWithRetries(client, request, attempt, findConflicts, isAborted) {
  const { codePrefix, code: requestedCode, codeNamespace, codeScope, ...sequence } = request;
  if (codePrefix === void 0 === (requestedCode === void 0)) {
    throw new Error("Allocation requires either a code prefix or a code to start from");
  }
  if (codePrefix === void 0 && codeNamespace === void 0) {
    throw new Error("Allocation requires a namespace to renumber a custom code from");
  }
  let seqNumber = await requestNumberAllocation(client, sequence);
  let code = codePrefix !== void 0 ? `${codePrefix}-${seqNumber}` : requestedCode;
  for (let attemptIndex = 0; attemptIndex < MAX_ALLOCATION_ATTEMPTS; attemptIndex++) {
    if (await attempt(seqNumber, code)) return { seqNumber, code, success: true };
    if (isAborted !== void 0 && await isAborted()) {
      return { seqNumber: -1, code, success: false, reason: "the allocation was aborted" };
    }
    const conflicts = await findConflicts(seqNumber, code);
    if (!conflicts.sequence && !conflicts.code) {
      return { seqNumber: -1, code, success: false, reason: "creation failed without an identifier conflict" };
    }
    if (conflicts.sequence || codePrefix !== void 0) {
      seqNumber = await requestNumberAllocation(client, { ...sequence, minimum: void 0 });
    }
    if (codePrefix !== void 0) {
      code = `${codePrefix}-${seqNumber}`;
    } else if (conflicts.code) {
      if (parseIdentifier(code) === null) {
        return { seqNumber: -1, code, success: false, reason: `the code ${code} is already taken` };
      }
      code = await requestNextIdentifier(client, code, codeNamespace, codeScope);
    }
  }
  return {
    seqNumber: -1,
    code,
    success: false,
    reason: `no free identifier after ${MAX_ALLOCATION_ATTEMPTS} attempts`
  };
}
__name(allocateWithRetries, "allocateWithRetries");
async function requestNextIdentifier(client, occupiedCode, namespace, scope) {
  const parsedCode = parseIdentifier(occupiedCode);
  if (parsedCode === null) {
    throw new Error(`Invalid identifier: ${occupiedCode}`);
  }
  return await requestIdentifierAllocation(client, {
    namespace,
    scope,
    prefix: parsedCode.prefix,
    minimum: parsedCode.sequence + 1
  });
}
__name(requestNextIdentifier, "requestNextIdentifier");
//# sourceMappingURL=identifier.js.map
